import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Handler from "../../../Helpers/Handler";
import { BsBookmarksFill } from "react-icons/bs";
import TablePlaceHolder from "../../../Components/TablePlaceHolder";
import Paging from "../../../Components/Paging";
import useListParams from "../../../Helpers/useListParams";

const LIMIT = 10;
const when = (value) => (value ? moment(new Date(value)).format("DD/MM/YYYY hh:mm A") : "-");

// This car's bookings, on the car's View page. Rows are the booking list API's own rows
// (bookingId, customerId, customerName, preBookDetails...) - they used to be read as
// element.booking.*, which doesn't exist, so every cell was blank and every link went to
// /booking/details/undefined. The page number is kept in the query (?bkPage=2) so coming
// Back from a booking returns to the same page - see Helpers/useListParams.
const BookingDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { page, setPage } = useListParams({}, { query: true, prefix: "bk" });
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [next, setNext] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        const response = await Handler({
            method: "POST",
            url: `/staff/booking/list/${page - 1}`,
            params: { limit: LIMIT },
            data: { carId: id, sortBy: "createdAt", sort: true },
        });
        if (response?.success && response?.data?.success) {
            setList(response?.data?.data?.list || []);
            setNext(Boolean(response?.data?.data?.next));
        } else {
            setList([]);
            setNext(false);
        }
        setLoading(false);
    }, [id, page]);

    useEffect(() => { load(); }, [load]);

    const open = (bookingId) => navigate(`/booking/details/${bookingId}`);

    return (
        <div className="card border-0 shadow-sm rounded-4 my-4">
            <div className="card-body">
                <div className="d-sm-flex justify-content-between mb-2">
                    <h5 className="fw-semibold d-flex align-items-center justify-content-sm-start justify-content-center mb-sm-0 mb-2 gap-2"><BsBookmarksFill /> Booking Details</h5>
                </div>
                <hr className="m-0" />
                <div className="overflow mt-4 mb-3">
                    <table className="table-bg w-100" borderless="true">
                        <thead>
                            <tr className="border-bottom">
                                <th className="p-1">Booking ID</th>
                                <th className="p-1">Customer</th>
                                <th className="p-1">Start</th>
                                <th className="p-1">End</th>
                                <th className="p-1">Stage</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? <TablePlaceHolder count={5} /> : list.length ? list.map((row) => (
                                <tr key={row.bookingId} className="mini-table-link-row" onClick={(event) => { if (!event.target.closest("a")) open(row.bookingId); }} title="Open booking">
                                    <td className="p-1"><Link to={`/booking/details/${row.bookingId}`}>{row.bookingId}</Link></td>
                                    <td className="p-1">
                                        {row.customerId ? <Link to={`/customers/${row.customerId}`}>{row.customerName || row.customerId}</Link> : (row.customerName || "-")}
                                        {row.customerPhone ? <div className="text-muted small">{row.customerPhone}</div> : null}
                                    </td>
                                    <td className="p-1">{when(row.preBookDetails?.startDate)}</td>
                                    <td className="p-1">{when(row.preBookDetails?.endDate)}</td>
                                    <td className="p-1">{row.bookingStage}</td>
                                </tr>
                            )) : <tr><td colSpan={5} className="text-center p-1">No bookings for this car yet</td></tr>}
                        </tbody>
                    </table>
                </div>
                <Paging previousValue={page > 1} nextValue={next} current={page} onPageChange={setPage} disabled={loading} />
            </div>
        </div>
    );
};

export default BookingDetails;
